module.exports = __webpack_public_path__ + "static/img/car_mg_vs_hev.084ca19b.png";